import { render, staticRenderFns } from "./appealFeedbackReview.vue?vue&type=template&id=ab08e07c&scoped=true"
import script from "./appealFeedbackReview.vue?vue&type=script&lang=js"
export * from "./appealFeedbackReview.vue?vue&type=script&lang=js"
import style0 from "./appealFeedbackReview.vue?vue&type=style&index=0&id=ab08e07c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab08e07c",
  null
  
)

export default component.exports